import { SubscriptionLevel } from "@dndbeyond/event-pipeline-lib/shared";

import type { AppUser } from "~/hooks/useUser";

const paidLevels = [
  SubscriptionLevel.Hero,
  SubscriptionLevel.Master,
  SubscriptionLevel.Legendary,
];

/**
 * Maps the user's subscription tier to the event pipeline SubscriptionLevel.
 * The tier claim casing isn't guaranteed, so match case-insensitively.
 */
export const getSubscriptionLevel = (
  user: AppUser | null | undefined
): SubscriptionLevel => {
  if (!user) return SubscriptionLevel.Visitor;

  const tier = user.subscriptionTier?.toLowerCase();
  const paidLevel = paidLevels.find((level) => level.toLowerCase() === tier);

  return paidLevel ?? SubscriptionLevel.RegisteredUser;
};
